import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session"; // session storage
import { combineReducers } from 'redux';
import data from '../slices/counterSlice';

const persistConfig = {
    key: "redux",
    storage,
    whitelist: ['data']
};

const rootReducer = combineReducers({ data });

export default persistReducer(persistConfig, rootReducer);